import { ORDER_STATUSES } from '@wareclouds/frontend-common/b2c';
import { apiInstances } from '../../../../../libs';

const { get } = apiInstances.orderInstance;

export default function getToReceiveCrossdockingOrders({
  page,
  status,
  idRoute = '',
  idWarecloud = '',
  orderSearch = '',
}) {
  return get(
    `orders/status/${ORDER_STATUSES.READY_TO_BE_DELIVERED}/crossdocking?page=${page}&status=${status}&id_route=${idRoute}&id_warecloud=${idWarecloud}&order_search=${orderSearch}`
  );
}
